export default {"src":"/_next/static/media/like_outline_icon.2c199852.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};